<template>
<modal-dialog
	:modal-visible="visible"
	:title="title"
	confirm-button-text="Save"
	v-on:confirm="confirmEditMaterial"
	v-on:closeModal="$emit('closeModal')">

	<template v-if="payload">
		<field label="Description" 
			col-class="col-md-4" 
			v-model="payload.description"
			:params="{type:'text',maxlength:110}">
		</field>

		<field label="Part #" 
			col-class="col-md-4" 
			v-model="payload.part_number">
		</field>

		<field :label="'Qty '+materialUnit" 
			v-on:change="setTotalMaterialPrice($event,'qty')"
			col-class="col-md-4" 
			:params="{type:'number',step:0.05}" 
			v-model="payload.qty">
		</field>

		<field label="Price" 
			v-on:change="setTotalMaterialPrice($event,'price')"
			col-class="col-md-4" 
			:params="{type:'number',min:0,step:0.01}" 
			v-model="payload.price">
		</field>

		<field label="Labour"
			col-class="col-md-4" 
			:params="{type:'number',min:0,step:0.001}" 
			v-model="payload.labour_hrs">
		</field>

		<field 
			label=" "
			col-class="col-md-4"
			class="mb-1"
			:params="{
				type:'boolean',
				doubleLabels:['Price by Markup','Price by Unit'],
			}"
			v-model="payload.manualUnitPrice">
		</field>

		<field :label="priceAdjustmentLabel ? priceAdjustmentLabel : 'Price Adjustment'" 
			v-on:change="setTotalMaterialPrice($event,'priceAdjustment')"
			col-class="col-md-4" 
			:params="{type:'number',min:0,step:0.001}" 
			v-model="payload.priceAdjustment"
			:readonly="payload.manualUnitPrice">

			<span class="text-muted">{{ priceAdjustmentLabel ? priceAdjustmentLabel : 'Price Adjustment' }} factor is not visible to the customer (ex. enter 1.2 for a 20% increase)</span>
		</field>

		<field
			v-if="!('summaryMarkup' in clientInvoiceSettings) || clientInvoiceSettings.summaryMarkup == 0" 
			label="Markup" 
			v-on:change="setTotalMaterialPrice"
			col-class="col-md-4" 
			:params="{type:'number',min:0,step:0.001}" 
			v-model="payload.markup"
			:readonly="payload.manualUnitPrice">

			<span class="text-muted">Markup factor is visible to customer (ex. enter 1.2 for a 20% markup)</span>
		</field>
		<field v-else
			:readonly="true"
			label="Markup"
			col-class="col-md-4"
			:value="payload.markup">
			For this customer markup is configured to be set equally for all materials. This can be changed in a Contact's Invoice Settings.
		</field>

		<field label="Total Unit Price" 
			col-class="col-md-4" 
			:readonly="!payload.manualUnitPrice"
			:params="{type:'number',min:0,step:0.01}"
			v-model="payload.totalUnitPrice"
			v-on:change="totalUnitPriceChange">
		</field>

		<field label="Total" 
			:readonly="true"
			col-class="col-md-4" 
			:value="lineTotal">
		</field>
	</template>

</modal-dialog>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"

import InvoiceMixins from "@/mixins/InvoiceMixins.js"

export default {
	name: "BillingDocumentMaterialEditModal",
	components: {
		Field,
		ModalDialog
	},
	mixins: [InvoiceMixins],
	props: ["visible","record","clientInvoiceSettings","title","priceAdjustmentLabel"],
	data() {
		return {
			payload: {
				type: "Material", //requird for saveObject argument
				invoice_id: this.invoiceId,
				field_values_json: "",
				manualUnitPrice: 0,
				price: 0
			},
			lineTotal: 0
		}
	},
	watch: {
		record() {
			this.setPayload()
			this.setTotalMaterialPrice()
		},
	},
	computed: {
		materialUnit() {
			if (this.record && "material_unit_type" in this.record)
				return this.record.material_unit_type
			return ""
		}
	},
	methods: {
		setPayload() {
			this.payload = this.cloneObj(this.record)
		},
		setTotalMaterialPrice(value,field) {
			let vm = this

			if (field)
				this.payload[field] = value

			let vals = vm.payload

			if (vals) {

				if (vals.per == 0)
					vals.per = 1

				if (!("manualUnitPrice" in vals) || !vals.manualUnitPrice) {

					if (!("markup" in vals) && !vals.markup)
						vals.markup = 1

					if (!("priceAdjustment" in vals) && !vals.priceAdjustment)
						vals.priceAdjustment = 1

					let totalUnitPrice = 0
					if (vals.price != 0)
						totalUnitPrice = +vals.price * +vals.priceAdjustment * +vals.markup

					vals.totalUnitPrice = totalUnitPrice.round(2)
				}

				let lineTotal = +vals.qty * +vals.price * +vals.priceAdjustment * +vals.markup / +vals.per

				vm.lineTotal = lineTotal.toCurrency()
			}


		},
		totalUnitPriceChange(value) {
			let vm = this

			vm.payload.markup = 1

			if (!("price" in vm.payload) || !vm.payload.price)
				vm.payload.price = 0

			vm.payload.priceAdjustment = +vm.payload.totalUnitPrice / +vm.payload.price

			vm.payload.priceAdjustment = +vm.payload.priceAdjustment.round(9)

			this.$forceUpdate()

			this.setTotalMaterialPrice()
		},
		confirmEditMaterial() {

			let vm = this

			let vals = vm.payload

			let lineTotal = +vals.qty * +vals.price * +vals.priceAdjustment * +vals.markup / +vals.per

			vm.payload.total = lineTotal.toCurrency()
			vm.payload.totalRaw = lineTotal

			let labourTotal = +vals.qty * vals.labour_hrs
			vm.payload.labourTotal = labourTotal.toCurrency()

			this.$emit("save",this.$data)
		}
	},
	created() {
		this.setPayload()

		this.setTotalMaterialPrice()
	}
}
</script>